import script from "./Knowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./Knowledge.vue?vue&type=script&setup=true&lang=js"

import "./Knowledge.vue?vue&type=style&index=0&id=6132abd2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6132abd2"]])

export default __exports__